/**
 * Commoner character calculations
 * A commoner is a character without a class - the simplest form of character.
 */

/** Commoner hit die is d4 */
export const COMMONER_HIT_DIE = 'd4';
export const COMMONER_HIT_DIE_MAX = 4;

/**
 * Calculate commoner hit points at level 1
 * HP = 4 + CON modifier (minimum 1)
 */
export function calculateCommonerHitPoints(constitutionModifier: number): number {
  return Math.max(1, COMMONER_HIT_DIE_MAX + constitutionModifier);
}

/**
 * Commoner proficiency information
 * Commoners have no class proficiencies - only what they get from race/background
 */
export const COMMONER_PROFICIENCIES = {
  savingThrows: [] as const,
  armor: [] as const,
  weapons: [] as const,
  tools: [] as const,
};
